import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedModule } from '@modules/shared.module';
import { NavigationService } from '@services/navigation-service/navigation-service.service';

@Component({
  selector: 'app-slide-filter-advanced',
  standalone: true,
  imports: [SharedModule],
  template: `
    <mat-slide-toggle (change)="emitirCambio($event)"> Filtros Avanzados </mat-slide-toggle>
  `,
  styleUrls: ['./slide-filter-advanced.component.css'],
})
export class SlideFilterAdvancedComponent {

  @Output() change = new EventEmitter<boolean>();
  @Input() disabled!: any
  @Input() isDialogClose: boolean = false




  constructor(private navigationService: NavigationService,
    private route: ActivatedRoute, private router: Router
  ) { }
  goBack(): void {
    if (this.isDialogClose)
      this.isDialogClose = !this.isDialogClose
    else
      this.navigationService.back();
  }

  emitirCambio(event: any) {
    this.change.emit(event.checked);
  }
}
